import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import "./ParallaxBackground.css";
export const ParallaxBackground = (props) => {
    // this refreshes the view. Tried using state index but failed to update past index 1
    const imageIndex = useRef(0);
    const switchImageSetup = useRef(false);
    const imageArray = [
        "./Images/Loading/LoadingParallax_1.webp",
        "./Images/Loading/LoadingParallax_2.webp",
        "./Images/Loading/LoadingParallax_3.webp",
        "./Images/Loading/LoadingParallax_4.webp",
        "./Images/Loading/LoadingParallax_5.webp",
    ];
    setTimeout(() => {
        if (switchImageSetup.current)
            return;
        const parallaxImage = document.getElementById("parallaxImg");
        parallaxImage === null || parallaxImage === void 0 ? void 0 : parallaxImage.addEventListener("animationiteration", () => {
            switchImage();
        });
        switchImageSetup.current = true;
    }, 100);
    const switchImage = () => {
        const nextIndex = imageIndex.current + 1;
        imageIndex.current = nextIndex >= imageArray.length ? 0 : nextIndex;
    };
    return (_jsxs(_Fragment, { children: [_jsx("img", { id: "parallaxForeground", alt: "LoadingForeground", src: "./Images/Loading/LoadingForeground.png" }), _jsx("div", Object.assign({ id: "parallaxImgHolder" }, { children: _jsx("img", { id: "parallaxImg", alt: "ParallaxImg", src: imageArray[imageIndex.current] }) })), _jsx("div", { id: "parallaxFade" })] }));
};
